import * as React from "react";
import { forwardRef } from "react";
const SvgBridCheckmark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 512, height: 512, viewBox: "0 0 512 512", fill: "currentColor", ref, "aria-labelledby": titleId, ...props }, title === void 0 ? /* @__PURE__ */ React.createElement("title", { id: titleId }, "ionicons-v5-e") : title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z", style: {
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 32
} }), /* @__PURE__ */ React.createElement("polyline", { points: "352 176 217.6 336 160 272", style: {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
} }));
const ForwardRef = forwardRef(SvgBridCheckmark);
export { ForwardRef as ReactComponent };
